/** The content types a project exposes, singular and plural where copy needs both. */
export type ContentTypeName =
  | "story"
  | "stories"
  | "webinar"
  | "webinars"
  | "article"
  | "articles"
  | "onDemand"
  | "event"
  | "events";

export type ContentTypeNames = Record<ContentTypeName, string>;

/**
 * The product's own vocabulary, and what the builder shows: authors work in one
 * wording no matter which brand or organization a project belongs to.
 *
 * Also the bottom layer of what visitors read. A brand and an organization can
 * each rename types (`contentTypeNames` on the whitelabel and company entities),
 * and a project can rename four of them through its tab titles — a separate,
 * translatable, plural-only mechanism. The player merges all of that in
 * `useContentNames`, which is the one place the order is decided; it can't live
 * here because these words are translation keys while a configured name is the
 * customer's own text, shown as-is.
 *
 * "Webinar" and "Event" are different things: a webinar is scheduled content an
 * organization publishes (and the only kind that can go in a collection or a
 * content-item block), while an event is created by users and lives on its own
 * page.
 */
export const CANONICAL_CONTENT_TYPE_NAMES: ContentTypeNames = {
  story: "Story",
  stories: "Stories",
  webinar: "Webinar",
  webinars: "Webinars",
  article: "Article",
  articles: "Articles",
  onDemand: "On Demand",
  event: "Event",
  events: "Events",
};
